import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) { return ({
    container: {
        // needed for fixed table header
        maxHeight: '100%',
        '&.form-table table, &.form-table table th, &.form-table .MuiInputBase-root': {
            background: theme.palette.background.paper,
        },
    },
    fade: {
        opacity: '0.7',
    },
    headerCellContent: {
        alignItems: 'center',
        display: 'inline-flex',
    },
    tableCellHeader: {
        color: theme.palette.common.black,
        fontSize: theme.typography.subtitle1.fontSize,
        lineHeight: '24px',
        fontWeight: 500,
        borderBottom: "1px solid " + theme.palette.custom.border,
        padding: theme.spacing(2, 1.5),
    },
    tableCellRoot: {
        borderBottom: "1px solid " + theme.palette.custom.border,
        padding: theme.spacing(2),
        '& .MuiChip-root': {
            marginLeft: '-2px',
        },
        '&.action-cell': {
            padding: theme.spacing(0, 0.5, 0, 2),
        },
        '& .action-button': {
            padding: theme.spacing(2, 1),
            borderRadius: 0,
        },
        '& .MuiSwitch-switchBase': {
            borderRadius: '50%',
        },
    },
    bodyRow: {
        '&:last-of-type td': {
            border: 0,
        },
    },
    noAction: {
        pointerEvents: 'none',
    },
    progress: {
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        zIndex: 10,
    },
    progressContainer: {
        border: 'none',
        position: 'relative',
    },
    sortable: {
        '&:hover': {
            color: theme.palette.primary.main,
            '& > svg': {
                color: theme.palette.primary.main,
            },
        },
    },
    sortIcon: {
        fontSize: '24px',
        marginLeft: theme.spacing(2),
        color: theme.palette.action.active,
    },
    table: {
        marginTop: theme.spacing(3),
        borderRadius: '8px',
        minWidth: theme.breakpoints.width('xs'),
        background: theme.palette.common.white,
    },
    formTableCell: {
        fontSize: '19px',
        lineHeight: '32px',
        padding: '99px 0 149px',
    },
    errorMessage: {
        display: 'flex',
        justifyContent: 'center',
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
}); });
